import { useMemo } from 'react';
import { SchoolYearValue, useResultsDataContext } from '../context/ResultsDataContext';
import uniqBy from 'lodash/uniqBy';

export function useSchools(selectedSchoolYear: SchoolYearValue | null) {
  const { groups } = useResultsDataContext();

  const schools = useMemo(() => {
    if (!groups) return;

    return uniqBy(
      groups
        .filter(group => group.acceptedMemberCount > 0 && group.schoolYear === selectedSchoolYear?.id)
        .map(x => x.school),
      'id',
    );
  }, [groups, selectedSchoolYear?.id]);

  return schools;
}
